module.exports = __webpack_public_path__ + "static/media/Desk_Calendar_Mockup_OK_3-768x591.5b9737ad.jpg";